import { render, staticRenderFns } from "./ProfilesTiles.vue?vue&type=template&id=6c0c6cbb&scoped=true&"
import script from "./ProfilesTiles.vue?vue&type=script&lang=js&"
export * from "./ProfilesTiles.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesTiles.vue?vue&type=style&index=0&id=6c0c6cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c6cbb",
  null
  
)

export default component.exports